import CourseSelect from "../../../Inputs/CourseSelect";
import ModalForm from "../../../Tools/ModalForm";
import { useState } from "react";

export default function Form({open, onClose, onSubmit}){

    const [course, setCourse] = useState();

    const handleSubmit = e => {
        e.preventDefault();
        return onSubmit({id: course})
    }

    return <ModalForm open={open} onClose={onClose} onSubmit={handleSubmit} title="Ajouter une formation">

        <CourseSelect 
            value=''
            onChange={id => setCourse(id)}
        />

    </ModalForm>
}